export { default } from './Modal';
export { default as ModalManager } from './ModalManager';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Modal/index.js
// module id = 372
// module chunks = 121